import { render, staticRenderFns } from "./privacyMerchant.vue?vue&type=template&id=1c272482&scoped=true"
import script from "./privacyMerchant.vue?vue&type=script&lang=js"
export * from "./privacyMerchant.vue?vue&type=script&lang=js"
import style0 from "./privacyMerchant.vue?vue&type=style&index=0&id=1c272482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c272482",
  null
  
)

export default component.exports